import React from "react";

function HowItWorks() {
  return (
    <section id="how-it-works" className="how-it-works">
      <div className="container">
        <h2>How ReHome Works</h2>
        <p className="intro-text">
          At ReHome, we believe every animal deserves a second chance. Our process ensures that rescued animals receive the care they need before finding loving forever homes. Here’s how you can be a part of this journey:
        </p>
        <div className="steps">
          <div className="step">
            <h3>Rescue & Rehome</h3>
            <p>We rescue animals in need, provide medical care, and help them find loving homes through a simple adoption process.</p>
          </div>
          <div className="step">
            <h3>Healing Community</h3>
            <p>Your donations and involvement help fund veterinary care, foster programs, and rescue operations, ensuring every animal gets a fair chance.</p>
          </div>
          <div className="step">
            <h3>Adoption Made Easy</h3>
            <p>Browse available pets, complete an adoption form, and connect with shelters or foster homes to bring your new companion home.</p>
          </div>
          <div className="step">
            <h3>Support & Educate</h3>
            <p>We provide resources on pet care, training, and responsible ownership to help families and animals thrive together.</p>
          </div>
        </div>
        <div className="cta-buttons">
          <a href="https://expo.dev/accounts/abhaykeshri/projects/rehome/builds/51e0ce25-9131-45cb-9b6c-f334b3cf0205" className="btn">Adopt a Pet</a>
          <a href="upi://pay?pa=7001072985@axl&pn=abhay&cu=INR&am" className="btn">Support Our Mission</a>
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;
